export const testimonials1 = [
  {
    picture: '/auth/avatars/vincent.jpg',
    name: 'Vincent L.',
    description: 'Marketing Coordinator',
    content: (
      <>
        The UI is friendly and the AI content assistant is surprisingly
        effective for professional tones. I especially like how it adjusts to
        different industries.
      </>
    ),
  },
  {
    picture: '/auth/avatars/dilini.jpeg',
    name: 'Dilini R.',
    description: 'AI & Tech Consultant',
    content: (
      <>
        I just found out about Postiz, a tool for scheduling social media.{' '}
        {'\n'}
        Exactly what I wish there was a few years back, I even thought of
        building one myself at one point, but didn't have the time to. {'\n'}
        What I like about it so far: {'\n\n'}
        It connects to LinkedIn, X, Instagram, Facebook (and others) from one
        dashboard. {'\n'}
        {'\n'}
        Because it's open-source, you can see how it works and even tweak it if
        you need to. {'\n'}
        {'\n'}
        I've used a few scheduling tools before and most of them are either
        expensive or try to be "all-in-one marketing platforms." {'\n'}
        {'\n'}
        Postiz seems to focus on just doing one thing well. {'\n'}
        {'\n'}
      </>
    ),
  },
  {
    picture: '/auth/avatars/johna.jpg',
    name: 'Johannes D.',
    description: 'CEO',
    content: (
      <>
        As a privacy-first company we appreciate being able to self-host Postiz!
        It brings all the core functionality of a social media scheduler plus a
        lot of AI to make things faster. It's also very easy to deploy and use,
        great work!
      </>
    ),
  },
  {
    picture: '/auth/avatars/george.jpg',
    name: 'George B.',
    description: 'Marketing Assistant',
    content: (
      <>
        It's so easy to jump in and start scheduling. I like that I can see all
        planned posts at a glance and edit them quickly if needed.
      </>
    ),
  },
  {
    picture: '/auth/avatars/maria.jpg',
    name: 'Maria Camila A.',
    description: 'Data Analyst',
    content: (
      <>
        Postiz changed how we manage our social media presence by aggregating
        our platforms into one effective tool. Post scheduling, and AI post
        ideation are two of the many features that come with Postiz, and have
        made our management of social media simple and effective! Highly
        recommend
      </>
    ),
  },
  {
    picture: '/auth/avatars/bart.jpg',
    name: 'Bartolomeo H.',
    description: 'CEO',
    content: (
      <>
        It only takes 10 minutes to set up your X scheduling automation. {'\n'}
        n8n + Postiz =🔥Never miss a day of posting again: {'\n\n'}→ Easy to get
        started {'\n'}→ Tutorial video included {'\n'}→ Automated content
        creation {'\n'}→ Multi-platform publishing {'\n'}→ Self-hosted (no
        monthly fees) {'\n'}→ Open-source (customize everything) {'\n'}
      </>
    ),
  },
  {
    picture: '/auth/avatars/henry.jpg',
    name: 'Henry H.',
    description: 'Social Media Coordinator',
    content: (
      <>
        The interface is clean and simple. I love how the AI assistant helps
        speed up caption writing without sounding generic. It's really helpful
        when I'm on a tight schedule.
      </>
    ),
  },
  {
    picture: '/auth/avatars/andy.jpeg',
    name: 'Andy C.',
    description: 'AI Specialist',
    content: (
      <>
        Manage all your social media accounts from a single place: Postiz, a
        really cool tool I recently discovered :D! {'\n'}
        It comes with a bunch of cool tools for posting at specific times,
        posting across multiple platforms simultaneously, etc. And all of this
        can potentially be self-hosted for free; you just need a small server to
        configure everything ;D! It works really well :D!
      </>
    ),
  },
];

export const testimonials2 = [
  {
    picture: '/auth/avatars/michael.jpeg',
    name: 'Michael H.',
    description: 'Senior frontend developer',
    content: (
      <>
        🌟 Exciting news! 🚀 I've just started using Postiz, a fantastic new
        tool for scheduling my social media content! {'\n\n'}
        Why did I choose Postiz? The ability to self-host it means significant
        savings for me! 💰 {'\n\n'}
        Postiz is an open-source scheduling tool that allows you to plan and
        automate posts across 19+ platforms, including X, LinkedIn, BlueSky, and
        Mastodon. {'\n\n'}
        With its powerful editor, you can easily connect your accounts, create
        rich scheduled posts, and manage multiple channels all in one place.
        Plus, it supports image uploads, recurring posts, and timezone-aware
        scheduling! 📅✨ {'\n\n'}
        Built with privacy and flexibility in mind, Postiz can run on your own
        infrastructure or be used as a hosted service. It's perfect for
        individuals, teams, and communities looking for control and automation
        without the unnecessary bloat. {'\n\n'}
      </>
    ),
  },
  {
    picture: '/auth/avatars/kiley.jpeg',
    name: 'Kiley H.',
    description: 'Content Creator',
    content: (
      <>
        The unified dashboard helps me manage Instagram, Facebook, and LinkedIn
        from one place. I love that it saves time and keeps our campaigns
        aligned across all platforms.
      </>
    ),
  },
  {
    picture: '/auth/avatars/iorn.jpg',
    name: 'Iornienge S.',
    description: 'Social Media Manager',
    content: (
      <>
        There are several things I love about this suite. Some of these things
        include {'\n'}- Ease of use {'\n'}- Helps me organize my social media
        accounts {'\n'}- I get work done faster {'\n'}- It does not consume my
        time {'\n'}- it has a professional interface {'\n'}
      </>
    ),
  },
  {
    picture: '/auth/avatars/david.jpg',
    name: 'David C.',
    description: 'Digital Marketing Manager',
    content: (
      <>
        Postiz makes it so easy to plan ahead. The AI suggestions are relevant,
        and the platform feels lightweight but powerful
      </>
    ),
  },
  {
    picture: '/auth/avatars/serge.jpeg',
    name: 'Serge A.',
    description: 'CEO',
    content: (
      <>
        Good tool for social media campaigns. The great thing is that the
        platform constantly evolves - new features appear all the time, so I can
        follow the latest trends (latest AI developments) without leaving
        Postiz.
      </>
    ),
  },
  {
    picture: '/auth/avatars/anica.jpg',
    name: 'Anica R.',
    description: 'University Applications Specialist',
    content: (
      <>
        It is easy to use, manages your posts simple.It is a helpful tool that
        let you organize your content.
      </>
    ),
  },
  {
    picture: '/auth/avatars/josh.jpg',
    name: 'Josh W.',
    description: 'Content Manager',
    content: (
      <>
        It's super easy to use even if you're not very techy. The AI writing
        tool gives good drafts so I don't have to start from scratch every time
      </>
    ),
  },
  {
    picture: '/auth/avatars/vince.jpeg',
    name: 'Vince C.',
    description: 'Developer Relations Engineer',
    content: (
      <>
        I work in Developer Relations, so having a tool that helps me manage and
        crosspost to different platforms saves me so, so, so much time!
      </>
    ),
  },
];
